import { LOCAL_SANCTIONS_URL } from "./const";
import { isEmpty } from "lodash";

export function getSanctionsUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const SANCTIONS_URL = !!process.env.REACT_APP_SANCTIONS_URL && process.env.REACT_APP_SANCTIONS_URL !== "" ? process.env.REACT_APP_SANCTIONS_URL : LOCAL_SANCTIONS_URL;
  if (!isEmpty(REACT_ENV)) {
    return SANCTIONS_URL;
  } else {
    return LOCAL_SANCTIONS_URL;
  }
}

export const getSanctionsUrlValue = () => {
  return getSanctionsUrl();
};
